import type { FC, ReactNode } from "react";
import { Card } from "./Card";
import "./StatCard.css";

type Props = {
	title: string;
	value: ReactNode;
	icon?: ReactNode;
	footer?: ReactNode;
};

export const StatCard: FC<Props> = ({ title, value, icon, footer }) => {
	return (
		<Card className="stat-card stat">
			<Card.Header>{title}</Card.Header>
			<Card.Body>
				<div className="stat-card-content">
					{icon && <div className="stat-card-icon">{icon}</div>}
					<div className="stat-card-value">{value}</div>
				</div>
				{footer && <div className="stat-card-footer">{footer}</div>}
			</Card.Body>
		</Card>
	);
};
